import { of, pipe } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { RecordingService } from '../services';
import { State } from '../services/work.state';

export const pcsData = () =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.system?.postCallSurveyData !== undefined) {
        const newState = {
          ...state,
          ...{
            postCallSurveyData: state.system?.postCallSurveyData,
            system: {
              ...state.system,
              ...{
                postCallSurveyData: undefined,
              },
            },
          },
        };
        return of([newState, currentState] as [Partial<State>, State]);
      }

      return of([state, currentState] as [Partial<State>, State]);
    })
  );
